export const PREFECTURES_FEATURE_KEY = "prefectures";
